import { fetchUserByUsername } from '@/api/query'
import { getInjectiveAddress } from '@ninjablaze/sdk-ts'
import posthog from 'posthog-js'
import { useCallback } from 'react'
import { useLocalStorage } from 'usehooks-ts'

interface ReferrerStorage {
  address: string
  time: number
  campaign: string | null
}

export const useReferrer = () => {
  const [referrerLocalStorage, setReferrerLocalStorage] = useLocalStorage<ReferrerStorage | undefined>(
    'referrer',
    undefined
  )

  const saveReferrer = useCallback(
    async (referrer: string, campaign: string | null) => {
      posthog.capture('ref_entered', {
        referrer: referrer,
      })

      if (!campaign) {
        posthog.capture('ref_campaign_entered', {
          referrer: campaign,
        })
      }

      if (referrerLocalStorage) {
        return
      }

      if (referrer.startsWith('0x') && referrer.length > 16) {
        setReferrerLocalStorage({
          address: getInjectiveAddress(referrer),
          time: Date.now(),
          campaign: campaign,
        })
        posthog.capture('set-ref', {
          referrer: referrer,
        })
        return
      }

      const profile = await fetchUserByUsername(referrer)

      if (!profile) {
        return
      }

      setReferrerLocalStorage({
        address: profile.address,
        time: Date.now(),
        campaign: campaign,
      })

      posthog.capture('ref_saved', {
        referrer: referrer,
      })
    },
    [referrerLocalStorage, setReferrerLocalStorage]
  )

  return {
    referrer: referrerLocalStorage?.address,
    campaign: referrerLocalStorage?.campaign,
    saveReferrer,
  }
}
